import { NewsletterComponent } from './newsletter.component'

/**
 * Self-initializing entry point for the shared newsletter signup component.
 *
 * The built bundle (``newsletter_widget/dist/assets/ts-index.js``) is loaded
 * by the ``newsletter_widget/newsletter_widget.html`` template when the widget
 * is included on a page.
 */
const init = (): void => {
  const el = document.querySelector('[data-newsletter-component]')
  if (!el) return
  new NewsletterComponent()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
